import {SAVE_TIPOS_ENVIO, TipoEnvioActionTypes} from "../types/tipoEnvioActionTypes";
import {ITipoEnvio} from "../../entities/catalogos/ITipoEnvio";

export function saveTiposEnvio(tiposEnvio: ITipoEnvio[]): TipoEnvioActionTypes {
    return{
        type: SAVE_TIPOS_ENVIO,
        tiposEnvio
    }
}
